import React from 'react';
import { Link } from 'react-router-dom';

const StatCard = ({ title, value, icon: Icon, linkTo, linkText, color }) => {
  return (
    <div className="bg-white rounded-lg shadow p-6">
      <div className="flex items-center">
        <div className={`rounded-md p-3 ${color}`}>
          <Icon className="h-6 w-6 text-white" />
        </div>
        <div className="ml-5">
          <h3 className="text-lg font-medium text-gray-900">{title}</h3>
          <div className="mt-1">
            <span className="text-2xl font-semibold">{value}</span>
          </div>
        </div>
      </div>
      {linkTo && (
        <div className="mt-6">
          <Link
            to={linkTo}
            className="text-sm font-medium text-primary-600 hover:text-primary-700"
          >
            {linkText} →
          </Link>
        </div>
      )}
    </div>
  );
};

export default StatCard;